import * as Sentry from "@sentry/browser";

import React, { useState } from "react";

import ActionIconButton from "./actionIconButton";
import CopyIcon from "~/icons/copyIcon";
import { Tooltip } from "@material-ui/core";
import { useTranslation } from "react-i18next";

interface CopyButtonProps {
  textToCopy: string;
  disabled?: boolean;
}

const CopyButton: React.FC<CopyButtonProps> = ({
  textToCopy,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const [showCopyTooltip, setShowCopyTooltip] = useState(false);

  const handleCopy = async () => {
    if (!textToCopy) return;

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(textToCopy);
      } else {
        // Fallback for browsers that don't support clipboard API
        // Also on local setups i.e. non https
        const textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand("copy");
        textArea.remove();
      }
      setShowCopyTooltip(true);
      setTimeout(() => setShowCopyTooltip(false), 2000); // Hide tooltip after 2 seconds
    } catch (err) {
      Sentry.captureException(err, {
        tags: {
          source: "Copy Button",
        },
      });
    }
  };

  return (
    <Tooltip
      open={showCopyTooltip}
      title={t("common.copiedToClipboard")}
      placement="top"
    >
      <ActionIconButton disabled={disabled} onClick={handleCopy}>
        <CopyIcon />
      </ActionIconButton>
    </Tooltip>
  );
};

export default CopyButton;
